<script lang="ts">
  import type { TimelineEntry } from "./types";
  import Caret from "~icons/ph/caret-down";
  import Check from "~icons/ph/check";
  import { jsonStorage } from "../../stores/storage";

  let {
    label,
    entries,
    done,
    name,
  }: {
    label: string;
    entries: TimelineEntry[];
    done?: boolean;
    name: string;
  } = $props();

  const checkClass = $derived(`rounded-full flex justify-center items-center ${done ? "bg-emerald-100" : "border-2 border-blue-300 bg-white"}`);
  const lineClass = $derived(done ? "bg-gray-200" : "bg-[repeating-linear-gradient(to_bottom,transparent_0px_4px,theme(colors.gray.200)_4px_8px)]");

  // svelte-ignore state_referenced_locally
  const open = jsonStorage(name, false); // Persist the open state of details using localStorage
</script>

<details class="group py-4 last:pb-0" bind:open={$open}>
  <summary class="font-medium cursor-pointer flex justify-between items-center gap-2 list-none [&::-webkit-details-marker]:hidden">
    <div class="flex items-center gap-2">
      <div class="h-6 w-6 {checkClass}">
        {#if done}<Check class="h-3.5 w-3.5 text-emerald-700"/>{/if}
      </div>
      {label}
    </div>
    <Caret class="h-4 w-4 shrink-0 transition-transform group-open:rotate-180"/>
  </summary>

  <div class="grid grid-cols-[3.5rem_1fr] items-start gap-x-3 pt-4">
    {#each entries as entry, i}
      <div class="flex items-center justify-between gap-1 z-10">
        <div class="text-[0.625rem] min-w-0 max-h-5">
          <span class:sr-only={i > 0 && entry.display_date === entries[i - 1].display_date}>{entry.display_date}</span>
        </div>
        <div class="h-5 w-5 {checkClass} shrink-0">
          {#if done}<Check class="h-3 w-3 text-emerald-700"/>{/if}
        </div>
      </div>
      <div class="relative pb-4 last:pb-0 group/entry">
        <div class="font-medium mb-1">{entry.title}</div>
        <div class="text-sm text-gray-600">{@html entry.description_html}</div>
        <div class="absolute w-0.5 top-0 bottom-0 -left-[1.4375rem] {lineClass} group-last/entry:hidden"></div>
      </div>
    {/each}
  </div>
</details>
